// extracted by mini-css-extract-plugin
export var boldText = "_5x-4";
export var checkboxContainer = "_5x-6";
export var closeIcon = "_5x-i";
export var container = "_5x-0";
export var drawer = "_5x-8";
export var drawerContent = "_5x-9";
export var extraSmallText = "_5x-5";
export var fulfillmentGroupTable = "_5x-e";
export var largeText = "_5x-3";
export var loadingSpinnerContainer = "_5x-j";
export var mediumText = "_5x-2";
export var narrow = "_5x-f";
export var notificationLink = "_5x-l";
export var packageCheckIconContainer = "_5x-7";
export var slideoutHeaderActions = "_5x-g";
export var slideoutHeaderActionsShifted = "_5x-h";
export var slideoutHeaderContainer = "_5x-a";
export var slideoutModal = "_5x-c";
export var stickyHeaderWrapper = "_5x-b";
export var table = "_5x-k";
export var tableContainer = "_5x-d";
export var tertiaryText = "_5x-1";